import { useExecuteAiFeatures } from '../hooks/api'
import { useCallback, useState } from 'react'
import { useAppDispatch, useAppSelector } from '../../../../../store/hooks'
import { formExecuteStarted, removeFormAiAgentResults, setFormAiAgentResult } from '../../../../../store/meetingSummary/forms'
import { selectSelectedMeetingTemplate } from '../../../../../store/meetingSummary/meetingTemplates'
import { useUpdateAiAgentResultMutation } from '../../../../../store/ai/aiAgentResult'
import { selectAccountId } from '../../../../../store/auth/authSlice'

export const useExecuteForm = () => {
  const dispatch = useAppDispatch()

  const selectedMeetingTemplate = useAppSelector(selectSelectedMeetingTemplate)

  const executeAiFeatures = useExecuteAiFeatures()

  return useCallback(
    async (aiFeatureId: string) => {
      if (!selectedMeetingTemplate) {
        return
      }
      dispatch(formExecuteStarted(aiFeatureId))
      await executeAiFeatures([aiFeatureId], selectedMeetingTemplate.id)
      dispatch(removeFormAiAgentResults(aiFeatureId))
    },
    [dispatch, selectedMeetingTemplate, executeAiFeatures],
  )
}

export const useUpdateFormResult = () => {
  const dispatch = useAppDispatch()

  const accountId = useAppSelector(selectAccountId)

  const [updateLoading, setUpdateLoading] = useState<boolean>(false)

  const [updateAiAgentResult] = useUpdateAiAgentResultMutation()

  const updateFormResult = useCallback(
    async (aiAgentResultId: string, result: { [key: string]: any }) => {
      setUpdateLoading(true)
      try {
        const newResult = await updateAiAgentResult({
          accountId,
          aiAgentResultId,
          body: {
            result,
          },
        }).unwrap()
        dispatch(setFormAiAgentResult(newResult))
      } catch (e) {
        console.error(e)
      } finally {
        setUpdateLoading(false)
      }
    },
    [dispatch, accountId, updateAiAgentResult],
  )

  return { updateLoading, updateFormResult }
}
